// Validação compartilhada da tela de conectar e da de reconectar o NAVI App.
export const NAVIAPP_DOCS_URL = 'https://naviapp.ai/docs';
export const TENANT_ID_FORMAT =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export const API_KEY_FORMAT = /^nvk_(live|test)_\S+$/;

export const isValidTenantId = value => TENANT_ID_FORMAT.test(value || '');
export const isValidApiKey = value => API_KEY_FORMAT.test(value || '');

// Mensagem do servidor (422 e 402 vêm em { error }); 402 cai no texto de limite.
export const naviappErrorMessage = (error, t) => {
  const { status, data = {} } = error?.response || {};
  if (data.error || data.message) return data.error || data.message;
  return status === 402
    ? t('INBOX_MGMT.ADD.NAVIAPP.LIMIT_REACHED')
    : t('INBOX_MGMT.ADD.NAVIAPP.ERROR');
};
